export const LinkTreeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 18.25 15.37"
    width="40px"
    height="40px"
  >
    <polygon points="-0.6 -0.01 -0.6 -0.01 -0.6 -0.01 -0.6 -0.01"></polygon>
    <path
      fill="#39e09b"
      d="M7.39.43A.82.82,0,0,0,6.28.12.77.77,0,0,0,6,.43L.68,10a.73.73,0,0,0,.67,1.05H4.92v3.63a.69.69,0,0,0,.68.68H7.69a.69.69,0,0,0,.68-.68V11.08h-1A.75.75,0,0,1,6.65,10L9.6,4.68Z"
      transform="translate(-0.6 -0.01)"
    ></path>
    <path
      fill="#28bf7b"
      d="M12.06.43a.81.81,0,0,1,1.1-.31.8.8,0,0,1,.32.31L18.77,10a.73.73,0,0,1-.68,1.05h-3.5v3.63a.69.69,0,0,1-.68.68H11.69a.69.69,0,0,1-.67-.68V11.08h1A.75.75,0,0,0,12.74,10l-3-5.35Z"
      transform="translate(-0.6 -0.01)"
    ></path>
  </svg>
);
